import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class MagicSlider extends Component {
  index = 0;
  touchStartX = null;
  isMobile = typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  oncreate(vnode) {
    const ms = Number(vnode.attrs.autoplayMs || 0);
    if (vnode.attrs.slides.length > 1 && ms > 0) {
      this.interval = window.setInterval(() => {
        this.next(vnode.attrs.slides.length);
        m.redraw();
      }, ms);
    }
    if (window.matchMedia) {
      this.mq = window.matchMedia('(max-width: 768px)');
      this.mqHandler = () => {
        this.isMobile = !!this.mq?.matches;
        m.redraw();
      };
      this.mq.addEventListener ? this.mq.addEventListener('change', this.mqHandler) : this.mq.addListener(this.mqHandler);
    }
  }
  onremove() {
    if (this.interval) {
      window.clearInterval(this.interval);
      this.interval = undefined;
    }
    if (this.mq && this.mqHandler) {
      this.mq.removeEventListener ? this.mq.removeEventListener('change', this.mqHandler) : this.mq.removeListener(this.mqHandler);
      this.mqHandler = undefined;
    }
  }
  next(len) {
    this.index = (this.index + 1) % len;
  }
  prev(len) {
    this.index = (this.index - 1 + len) % len;
  }
  onPointerDown(e) {
    this.touchStartX = e.clientX ?? 0;
  }
  onPointerUp(e, len) {
    if (this.touchStartX === null) return;
    const dx = (e.clientX ?? 0) - this.touchStartX;
    this.touchStartX = null;
    if (Math.abs(dx) > 40) {
      dx < 0 ? this.next(len) : this.prev(len);
      m.redraw();
    }
  }
  slideLinkLabel(i, total, hasLink) {
    return hasLink ? `Open slide ${i + 1} of ${total}` : `Slide ${i + 1} of ${total}`;
  }

  /**
   * Best-effort, fire-and-forget — never blocks or delays the actual
   * navigation the visitor just triggered by clicking the slide, and never
   * surfaces an error if it fails (there's no UI here to show one in, and a
   * missed click count isn't worth interrupting anything over).
   */
  recordClick(id) {
    if (!id) return;
    app.request({
      method: 'POST',
      url: `${app.forum.attribute('apiUrl')}/forumaker/magicslider/click`,
      body: {
        id
      },
      background: true
    }).catch(() => {});
  }
  slideButtonLabel(i, active) {
    return active ? `Current slide ${i + 1}` : `Go to slide ${i + 1}`;
  }
  viewInner(vnode) {
    const {
      slides,
      heightDesktop,
      heightMobile,
      paddingDesktop,
      paddingMobile,
      radiusDesktop,
      radiusMobile
    } = vnode.attrs;
    if (!slides.length) return null;
    if (this.index >= slides.length) {
      this.index = 0;
    }
    const offsetPct = -(this.index * 100);
    const pad = this.isMobile ? paddingMobile : paddingDesktop;
    const rad = this.isMobile ? radiusMobile : radiusDesktop;
    return m("div", {
      className: "MagicSlider-wrap",
      style: {
        padding: `${pad}px`
      }
    }, m("div", {
      className: "MagicSlider",
      style: {
        borderRadius: `${rad}px`,
        ['--ms-h-desktop']: `${heightDesktop}px`,
        ['--ms-h-mobile']: `${heightMobile}px`
      },
      onpointerdown: e => this.onPointerDown(e),
      onpointerup: e => this.onPointerUp(e, slides.length),
      "aria-label": "Homepage slider"
    }, m("div", {
      className: "MagicSlider-track",
      style: {
        transform: `translateX(${offsetPct}%)`
      }
    }, slides.map((s, i) => {
      const isFirst = i === 0;
      const label = this.slideLinkLabel(i, slides.length, !!s.link);
      const image = m("img", {
        className: "MagicSlide-image",
        src: s.image,
        alt: "",
        "aria-hidden": "true",
        draggable: false,
        fetchpriority: isFirst ? 'high' : 'low',
        loading: isFirst ? 'eager' : 'lazy',
        decoding: "async"
      });
      if (s.link) {
        return m("a", {
          key: i,
          className: "MagicSlide",
          href: s.link,
          target: s.newTab ? '_blank' : '_self',
          rel: s.newTab ? 'noopener noreferrer' : undefined,
          "aria-label": label,
          onclick: () => s.id && this.recordClick(s.id)
        }, image);
      }
      return m("div", {
        key: i,
        className: "MagicSlide",
        "aria-label": label
      }, image);
    })), slides.length > 1 && m('[', null, m("button", {
      type: "button",
      className: "MagicSlider-btn prev",
      "aria-label": "Previous slide",
      onclick: () => {
        this.prev(slides.length);
        m.redraw();
      }
    }, m("span", {
      className: "MagicSlider-btnVisual"
    }, m("i", {
      className: "fas fa-chevron-left"
    }))), m("button", {
      type: "button",
      className: "MagicSlider-btn next",
      "aria-label": "Next slide",
      onclick: () => {
        this.next(slides.length);
        m.redraw();
      }
    }, m("span", {
      className: "MagicSlider-btnVisual"
    }, m("i", {
      className: "fas fa-chevron-right"
    }))), m("div", {
      className: "MagicSlider-dots",
      "aria-label": "Slider pagination"
    }, slides.map((_, i) => {
      const isActive = this.index === i;
      return m("button", {
        key: i,
        type: "button",
        className: 'dot' + (isActive ? ' is-active' : ''),
        "aria-label": this.slideButtonLabel(i, isActive),
        "aria-current": isActive ? 'true' : 'false',
        onclick: () => {
          this.index = i;
          m.redraw();
        }
      }, m("span", {
        className: "dotInner",
        "aria-hidden": "true"
      }));
    })))));
  }
  view(vnode) {
    const {
      fitToLayout
    } = vnode.attrs;
    if (fitToLayout) {
      return m("div", {
        className: "MagicSlider-outer"
      }, m("div", {
        className: "container"
      }, m("div", {
        className: "sideNavOffset"
      }, this.viewInner(vnode))));
    }
    return this.viewInner(vnode);
  }
}
flarum.reg.add('forumaker-magicslider', 'forum/components/MagicSlider', MagicSlider);